var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagePlaneGolden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1409_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8951 23.8699L1.33522 13.1944C1.12768 13.0865 0.952467 12.9171 0.829819 12.7058C0.70717 12.4945 0.64209 12.2498 0.64209 12C0.64209 11.7502 0.70717 11.5055 0.829819 11.2942C0.952467 11.0829 1.12768 10.9135 1.33522 10.8056L21.8951 0.130081C22.106 0.0203648 22.3415 -0.021246 22.5735 0.0102062C22.8055 0.0416565 23.0243 0.144844 23.2038 0.307478C23.3834 0.47011 23.5161 0.685335 23.5861 0.927517C23.6561 1.1697 23.6606 1.42863 23.5989 1.67347L21.5419 9.8597C21.5167 9.96002 21.4649 10.0501 21.3929 10.1187C21.3209 10.1872 21.2319 10.2313 21.137 10.2453L11.1741 11.7145C11.1326 11.7208 11.0932 11.7387 11.0599 11.7663C11.0266 11.794 11.0004 11.8305 10.9838 11.8724L10.9663 11.9391C10.9586 11.9982 10.9695 12.0585 10.9973 12.11C11.0252 12.1615 11.0682 12.2013 11.1195 12.223L11.1731 12.2389L21.1262 13.7071C21.221 13.7213 21.3098 13.7654 21.3816 13.8339C21.4534 13.9025 21.5051 13.9925 21.5302 14.0926L23.5989 22.3265C23.6606 22.5714 23.6561 22.8303 23.5861 23.0725C23.5161 23.3147 23.3834 23.5299 23.2038 23.6925C23.0243 23.8552 22.8055 23.9583 22.5735 23.9898C22.3415 24.0212 22.106 23.9796 21.8951 23.8699Z",
    fill: "url(#paint0_linear_1409_85)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1409_85",
    x1: 23.6028,
    y1: 11.9967,
    x2: 0.642351,
    y2: 11.9967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2279,
    stopColor: "#E8D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#D7B15E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#E4B553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#E7D359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDE61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1409_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagePlaneGolden);
export default __webpack_public_path__ + "static/media/message-plane-golden.e824b657c36deb6590e702437aae96cd.svg";
export { ForwardRef as ReactComponent };